import React from "react";
import { AppBar, Card, Toolbar, Typography } from "@mui/material";
import packageJson from "../../../../package.json";

import ProductionBoardLogoHorizontal from "../../../images/production-board-logo";
import DashboardSections from "../components/dashboardSections";
import Badge from "../../../components/Badge";
import LogoutButton from "./logoutButton";

function Header() {
  const user = JSON.parse(localStorage.getItem("user")).user;
  return (
    <AppBar sx={styles.appBar}>
      <Toolbar sx={styles.toolbar}>
        <ProductionBoardLogoHorizontal />
        <Card sx={styles.versionCard}>
          <Typography
            component="span"
            variant="caption"
            sx={styles.versionText}
          >
            v{packageJson.version}
          </Typography>
        </Card>
        <DashboardSections userType={user?.type} />
        <Typography variant="h5">{user?.name + " " + user?.surname}</Typography>
        <Badge label={user?.type} bgColor="#E0F2FE" textColor="#0A0D12" />
        <LogoutButton />
      </Toolbar>
    </AppBar>
  );
}

export default React.memo(Header);

const styles = {
  toolbar: {
    minHeight: "72px !important",
    px: 3,
    display: "flex",
    alignItems: "center",
    gap: 2,
  },
  appBar: {
    boxShadow: "none",
    position: "fixed",
    zIndex: 1201,
    backgroundColor: "#FDFDFD",
    borderBottom: "1px solid #E9EAEB",
  },
  versionCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "4px 8px",
    gap: "10px",
    borderRadius: "8px",
    border: "1px solid #E9EAEB",
    boxShadow: "none",
  },
  versionText: {
    color: "#717680",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
  },
};
